import(/* webpackMode: "eager" */ "/root/enhanci-frontend/app/terms-of-service/page.tsx")